// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 923 ? "zxcvbn" : chunkId) + "." + {"787":"0e9232b2","923":"b5fa0a3e"}[chunkId] + ".chunk.js";
};